function initializeSearch() {
  // Find all search inputs with AJAX enabled
  const searchInputs = document.querySelectorAll('input[data-ajax-search="enabled"]');

  searchInputs.forEach(searchInput => {
    initializeSearchInput(searchInput);
  });
}

function initializeSearchInput(searchInput) {
  // Look for suggestions container - either specific to this input or the default one
  const inputId = searchInput.id;
  let searchResults = null;

  if (inputId === 'nav-search-input') {
    // For navigation search, create suggestions container if it doesn't exist
    searchResults = searchInput.parentElement.querySelector('.search-suggestions');
    if (!searchResults) {
      searchResults = document.createElement('div');
      searchResults.className = 'search-suggestions w-100 d-none shadow-lg position-absolute';
      searchResults.style.cssText = 'max-height: 400px; overflow-y: auto; z-index: 1050; top: 100%; left: 0; right: 0;';
      searchInput.parentElement.style.position = 'relative';
      searchInput.parentElement.appendChild(searchResults);
    }
  } else {
    // For other search inputs, look for the default suggestions container
    searchResults = document.querySelector('#search-suggestions');
  }

  if (!searchResults) return;

  let searchTimeout;

  // Debounced search function
  function performSearch(query) {
    if (query.length < 2) {
      if (searchResults) {
        searchResults.innerHTML = '';
        searchResults.classList.add('d-none');
      }
      return;
    }

    fetch(`/api/search?q=${encodeURIComponent(query)}&locale=${document.documentElement.lang === 'en' ? 'en' : 'de'}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (searchResults) {
        displaySearchSuggestions(data);
      }
    })
    .catch(error => {
      console.error('Search error:', error);
    });
  }

  // Display search suggestions
  function displaySearchSuggestions(data) {
    if (data.total_results === 0) {
      searchResults.innerHTML = `
        <div class="search-suggestion-section">
          <div class="search-item-content p-3 text-center text-muted">
            <i class="fas fa-search mb-2"></i><br>
            Keine Ergebnisse gefunden
          </div>
        </div>
      `;
      searchResults.classList.remove('d-none');
      return;
    }

    let html = '';

    // Add topics first
    if (data.topics.length > 0) {
      html += '<div class="search-suggestion-header">THEMEN</div>';
      data.topics.forEach(topic => {
        html += `
          <a href="${topic.url}" class="search-suggestion-item topic-suggestion d-flex align-items-center">
            <div class="search-item-content">
              <div class="search-item-title">${topic.name} Schulungen</div>
              <div class="search-item-meta">${topic.course_count} Schulung${topic.course_count !== 1 ? 'en' : ''}</div>
              ${topic.description ? `<div class="search-item-description">${topic.description.substring(0, 80)}...</div>` : ''}
            </div>
          </a>
        `;
      });
    }

    // Add tracks (Lernpfade)
    if (data.tracks && data.tracks.length > 0) {
      html += '<div class="search-suggestion-header">LERNPFADE</div>';
      data.tracks.forEach(track => {
        const logoUrl = track.logo_url;
        html += `
          <a href="${track.url}" class="search-suggestion-item track-suggestion d-flex align-items-center">
            ${logoUrl ? `<img src="${logoUrl}" alt="${track.name}" width="30" height="30" class="me-3 rounded">` : ''}
            <div class="search-item-content">
              <div class="search-item-title">${track.name} Lernpfad</div>
              <div class="search-item-meta">${track.course_count} Kurs${track.course_count !== 1 ? 'e' : ''}</div>
              ${track.description ? `<div class="search-item-description">${track.description.substring(0, 80)}...</div>` : ''}
            </div>
          </a>
        `;
      });
    }

    // Add courses
    if (data.courses.length > 0) {
      html += '<div class="search-suggestion-header">KURSE</div>';
      data.courses.forEach(course => {
        const logoUrl = course.logo_url;
        html += `
          <a href="${course.url}" class="search-suggestion-item course-suggestion d-flex align-items-center">
            ${logoUrl ? `<img src="${logoUrl}" alt="${course.title}" width="30" height="30" class="me-3 rounded">` : ''}
            <div class="search-item-content">
              <div class="search-item-title">${course.title}</div>
              <div class="search-item-meta">${course.type}</div>
              ${course.description ? `<div class="search-item-description">${course.description.substring(0, 80)}...</div>` : ''}
            </div>
          </a>
        `;
      });
    }

    // Add blog posts
    if (data.posts && data.posts.length > 0) {
      html += '<div class="search-suggestion-header">BLOG</div>';
      data.posts.forEach(post => {
        const imageUrl = post.image_url;
        html += `
          <a href="${post.url}" class="search-suggestion-item post-suggestion d-flex align-items-center">
            ${imageUrl ? `<img src="${imageUrl}" alt="${post.title}" width="30" height="30" class="me-3 rounded">` : ''}
            <div class="search-item-content">
              <div class="search-item-title">${post.title}</div>
              ${post.author ? `<div class="search-item-meta">${post.author}</div>` : ''}
              ${post.description ? `<div class="search-item-description">${post.description.substring(0, 80)}...</div>` : ''}
            </div>
          </a>
        `;
      });
    }

    // Add "show all results" link
    html += `
      <div class="search-suggestion-section search-all-results">
        <a href="/search?q=${encodeURIComponent(data.query)}" class="search-all-link">
          Alle ${data.total_results} Ergebnisse anzeigen
        </a>
      </div>
    `;

    searchResults.innerHTML = html;
    searchResults.classList.remove('d-none');
  }

  // Hide suggestions when clicking outside (specific to this search input)
  function handleClickOutside(event) {
    if (searchResults && !searchInput.contains(event.target) && !searchResults.contains(event.target)) {
      searchResults.classList.add('d-none');
    }
  }

  // Search input event listener
  searchInput.addEventListener('input', function() {
    const query = this.value.trim();

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300); // 300ms debounce
  });

  // Add click outside handler for this specific search input
  document.addEventListener('click', handleClickOutside);

  // Show suggestions when focusing on search input (if there's a query)
  searchInput.addEventListener('focus', function() {
    const query = this.value.trim();
    if (query.length >= 2) {
      performSearch(query);
    }
  });

  // Store cleanup function on the element for potential future removal
  searchInput._searchCleanup = function() {
    document.removeEventListener('click', handleClickOutside);
  };
}

// Initialize on different events
document.addEventListener("turbo:load", initializeSearch);
document.addEventListener("DOMContentLoaded", initializeSearch);